import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Dropdown,
  Option,
  Text,
  Spinner,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface QuestionTypesDialogProps {
  isOpen: boolean;
  onClose: () => void;
  questions: any[];
  questionTypes: string[];
  onSend: (questions: any[]) => void;
  loading: boolean;
}

const QuestionTypesDialog: React.FC<QuestionTypesDialogProps> = ({
  isOpen,
  onClose,
  questions,
  questionTypes,
  onSend,
  loading,
}) => {
  const [localQuestions, setLocalQuestions] = useState<any[]>(questions);

  useEffect(() => {
    if (isOpen) {
      setLocalQuestions(questions);
    }
  }, [isOpen, questions]);

  const setQuestionType = (index: number, questionType: string) => {
    setLocalQuestions(localQuestions.map((q, i) => (i === index ? { ...q, questionType } : q)));
  };

  return (
    <Dialog modalType='alert' open={isOpen} onOpenChange={(_, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
              />
            }
          >
            Kontrollera frågetyperna
          </DialogTitle>
          <DialogContent className="min-w-[500px] max-h-[600px] overflow-y-auto">
            {loading ? (
              <div className="flex items-center justify-center p-8">
                <Spinner size="large" />
              </div>
            ) : (
              <div className="space-y-4">
                {localQuestions.map((q, index) => (
                  <div key={index} className="flex items-center gap-4 border-b border-gray-200 pb-3">
                    <Text className="flex-1">{`${q.heading} ${q.text}`}</Text>
                    <Dropdown
                      className="min-w-[200px]"
                      value={q.questionType || ''}
                      onOptionSelect={(_, data) => setQuestionType(index, data.optionValue as string)}
                    >
                      {questionTypes.map((type) => (
                        <Option key={type} value={type}>
                          {type}
                        </Option>
                      ))}
                    </Dropdown>
                  </div>
                ))}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => onSend(localQuestions)}
              disabled={loading || localQuestions.some((q) => !q.questionType)}
            >
              Skicka frågor
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default QuestionTypesDialog;
